import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import { ScalarType } from "./reflection-info";
/**
 * Determines whether two message of the same type have the same field values.
 * Checks for deep equality, traversing repeated fields, oneof groups, maps
 * and messages recursively.
 * Will also return true if both messages are `undefined`.
 */

export function reflectionEquals(info, a, b) {
  if (a === b) return true;
  if (!a || !b) return false;

  var _iterator = _createForOfIteratorHelper(info.fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      var localName = field.localName;
      var val_a = field.oneof ? a[field.oneof][localName] : a[localName];
      var val_b = field.oneof ? b[field.oneof][localName] : b[localName];

      switch (field.kind) {
        case "enum":
        case "scalar":
          var t = field.kind == "enum" ? ScalarType.INT32 : field.T;
          if (!(field.repeat ? repeatedPrimitiveEq(t, val_a, val_b) : primitiveEq(t, val_a, val_b))) return false;
          break;

        case "map":
          if (!(field.V.kind == "message" ? repeatedMsgEq(field.V.T(), objectValues(val_a), objectValues(val_b)) : repeatedPrimitiveEq(field.V.kind == "enum" ? ScalarType.INT32 : field.V.T, objectValues(val_a), objectValues(val_b)))) return false;
          break;

        case "message":
          var T = field.T();
          if (!(field.repeat ? repeatedMsgEq(T, val_a, val_b) : T.equals(val_a, val_b))) return false;
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}
var objectValues = Object.values;

function primitiveEq(type, a, b) {
  if (a === b) return true;
  if (type !== ScalarType.BYTES) return false;
  var ba = a;
  var bb = b;
  if (ba.length !== bb.length) return false;

  for (var i = 0; i < ba.length; i++) {
    if (ba[i] != bb[i]) return false;
  }

  return true;
}

function repeatedPrimitiveEq(type, a, b) {
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; i++) {
    if (!primitiveEq(type, a[i], b[i])) return false;
  }

  return true;
}

function repeatedMsgEq(type, a, b) {
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; i++) {
    if (!type.equals(a[i], b[i])) return false;
  }

  return true;
}